export default "__VITE_ASSET__D6_ZD0gN__"